import { ACCOUNT_TYPES, BREAKPOINTS, LINKS } from "../../app/appConstants.js";
import { Accordion } from "react-bootstrap";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import NewLifeAccountPanel from "./NewLifeAccountPanel";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
    NewLifeAccountButtonsStyled,
    NewLifeAccountCarouselStyled,
    NewLifeContentStyled,
    NewLifeHeadContentStyled,
    NewLifeHeaderStyled,
    NewLifeHeadStyled,
    NewLifeHelpStyled,
    NewLifeSubHeaderStyled
} from "./styled/NewLifeStyled.js";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks.js";
import BackButton from "../../components/BackButton/BackButton.jsx";
import { getNewLifeAccountsAction } from "../Bonus/bonusesActions.js";
import { getNewLifeAccounts } from "../Bonus/bonusesSelectors.js";
import { Carousel } from "../../components/carousel/Carousel.jsx";
import { useMaxWidthMediaQuery } from "../../components/responsive/responsive-hooks.js";
import NewLifeAccountButton from "./NewLifeAccountButton.jsx";
import { useGTMEvent } from "../GoogleTagManager/googleTagManagerHooks.js";
import { AccordionToggle } from "../../components/AccordionToggle/AccordionToggle.jsx";
import parseAccountName from "../../utils/parseAccountName.js";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function NewLife(props) {
    const {
        getNewLifeAccounts,
        newLifeAccounts,
    } = props;

    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent();
    const [selectedAccountName, setSelectedAccountName] = useState(null);
    const [selectedCarouselItem, setSelectedCarouselItem] = useState(0);
    const isMediumMaxWidth = useMaxWidthMediaQuery(BREAKPOINTS.medium);
    useSetBodyBackgroundColor('var(--app-bg-modal-panel-color)', true);
    const selectedAccount = useMemo(() =>
        newLifeAccounts.find(item => item.account === selectedAccountName), [newLifeAccounts, selectedAccountName]
    );

    useEffect(() => {
        getNewLifeAccounts();
    }, [getNewLifeAccounts]);

    useEffect(() => {
        if (!selectedAccountName) {
            const idx = newLifeAccounts.findIndex(item => item.type === ACCOUNT_TYPES.LIVE);
            setSelectedCarouselItem(idx || 0);
            setSelectedAccountName(newLifeAccounts[idx]?.account || null);
        }
    }, [newLifeAccounts, setSelectedCarouselItem, selectedAccountName])

    const handleAccountButtonClick = useCallback((accountName) => {
        const parsedAccount = parseAccountName(accountName);
        handleGTMClick({
            module: 'RespawnPage',
            button: `${parsedAccount.type}_account`
        });
        setSelectedAccountName(accountName);
    }, [handleGTMClick])

    const onRespawnSuccess = useCallback(() => {
        getNewLifeAccounts();
    }, [getNewLifeAccounts])

    const handleAccordionOpen = useCallback(() => handleGTMClick({
        module: 'RespawnPage',
        button: 'what_does_this_mean',
        action: 'Open'
    }), [handleGTMClick])

    const handleAccordionClose = useCallback(() => handleGTMClick({
        module: 'RespawnPage',
        button: 'what_does_this_mean',
        action: 'Close'
    }), [handleGTMClick])

    return <>

        <NewLifeHeadStyled>
            <NewLifeHeadContentStyled>
                <BackButton/>
                <NewLifeHeaderStyled>{getLangPath('bonus.new_life.respawn_title')}</NewLifeHeaderStyled>
                <NewLifeSubHeaderStyled>{getLangPath('bonus.new_life.respawn_subtitle')}</NewLifeSubHeaderStyled>
                <NewLifeHelpStyled>
                    <Accordion>
                        <Accordion.Item eventKey={0}>
                            <AccordionToggle
                                eventKey={0}
                                onClose={handleAccordionClose}
                                onOpen={handleAccordionOpen}
                            >
                                <span>{getLangPath('bonus.new_life.what_mean.title')}</span>
                            </AccordionToggle>
                            <Accordion.Body>
                                <div dangerouslySetInnerHTML={{
                                    __html: getLangPath('bonus.new_life.what_mean.text', {
                                        rules_link: LINKS.rulesNewLifeDoc,
                                    })
                                }}/>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </NewLifeHelpStyled>

                {
                    !isMediumMaxWidth &&
                    <NewLifeAccountButtonsStyled>
                        {
                            !!newLifeAccounts && newLifeAccounts.map((item) => (
                                <NewLifeAccountButton account={item}
                                                      key={item.account}
                                                      active={item.account === selectedAccount?.account}
                                                      onClickHandler={() => {
                                                          handleAccountButtonClick(item.account);
                                                      }}
                                                      style={{flexBasis: '50%'}}
                                />
                            ))
                        }
                    </NewLifeAccountButtonsStyled>
                }

                {
                    !!newLifeAccounts && isMediumMaxWidth &&
                    <NewLifeAccountCarouselStyled>
                        <Carousel showArrows={false} centerDots={true} onChange={(idx) => {
                            handleAccountButtonClick(newLifeAccounts[idx].account);
                        }} selectedItem={selectedCarouselItem}>
                            {newLifeAccounts.map((item, idx) => (
                                <NewLifeAccountButton account={item}
                                                      key={item.account}
                                                      active={item.account === selectedAccount?.account}
                                                      onClickHandler={() => {
                                                          setSelectedCarouselItem(idx);
                                                          handleAccountButtonClick(item.account);
                                                      }}
                                />
                            ))}
                        </Carousel>
                    </NewLifeAccountCarouselStyled>
                }
            </NewLifeHeadContentStyled>
        </NewLifeHeadStyled>
        <NewLifeContentStyled>
            {!!selectedAccount &&
                <NewLifeAccountPanel selectedAccount={selectedAccount} onRespawnSuccess={onRespawnSuccess}/>}
        </NewLifeContentStyled>
    </>
}

const mapStateToProps = createStructuredSelector({
    newLifeAccounts: getNewLifeAccounts,
})

const mapDispatchToProps = (dispatch) => ({
    getNewLifeAccounts: (payload) => dispatch(getNewLifeAccountsAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewLife);
